import React, { useState, useContext, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import typeScriptContext from "../../../../AppState/SystemConfig/appContext";
import { isMobile } from "react-device-detect";
import PDFSimple from "./PDF.jsx";

function ModalTratamientoDatos({ open, closeModal }) {
  const { AppManager, AppConfiguration } = useContext(typeScriptContext);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    AppManager.translator.changeLabelsTitle();
    if (firstLoad) setFirstLoad(false);
  }, [firstLoad, AppManager.translator]);

  return (
    <div className={AppConfiguration.theme}>
      <Dialog
        open={!!open}
        onClose={closeModal}
        fullScreen={isMobile}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : 2,
            overflow: "hidden",
          },
        }}
        sx={{
          zIndex: 1050, // debajo del modal obligatorio si lo pones en 20000
        }}
      >
        {/* Close */}
        <IconButton
          onClick={closeModal}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 2,
            bgcolor: "rgba(255,255,255,0.9)",
            "&:hover": { bgcolor: "rgba(255,255,255,1)" },
          }}
        >
          <CloseRoundedIcon />
        </IconButton>

        <DialogContent
          sx={{
            p: 0,
            height: isMobile ? "100vh" : 650,
            position: "relative",
          }}
        >
          {/* Área del PDF */}
          <Box
            height="100%"
            display="flex"
            justifyContent="center"
            sx={{
              overflowY: "auto" ,
              overflowX: "hidden",
              p: 2,
            }}
          >
            <PDFSimple preview={false} />
          </Box>

         
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default ModalTratamientoDatos;
